var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-main',{staticStyle:{"min-height":"70vh"}},[_c('v-container',{staticClass:"responsive-template-content"},[_c('v-row',{attrs:{"dense":""}},[_c('PersonalInformationForm'),_c('UpdatePasswordForm')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }